<template>
    <v-container justify-space-around wrap>
        <v-layout class="mt-6" justify-space-around>
            <v-flex lg9 mx-auto>
                <v-card class="green lighten-4 pa-6 mx-auto elevation-12">
                    <v-card-title class="justify-center">
                        <v-layout align-center>
                            <v-flex class="">
                                <div class="teal--text display-2 font-weight-bold text-center">렌트카의 특징</div>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-layout justify-center>
                            <v-card lg6 class="elevation-6">
                                <v-img src="../../assets/about1.png" width="650px"></v-img>
                            </v-card>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout class="mt-6" justify-space-around>
            <v-flex lg9 mx-auto>
                <v-card class="green lighten-4 pa-6 mx-auto elevation-12">
                    <v-card-title class="justify-center">
                        <v-layout align-center>
                            <v-flex class="">
                                <div class="teal--text display-2 font-weight-bold text-center">렌트카의 장점</div>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-layout justify-center>
                            <v-flex lg8 class="">
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="title font-weight-bold">이용 접근성</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            전국 900여 사업자 약 3000여개 영업망을 통해 이용자가 쉽게 이용
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="title font-weight-bold">차량 이용의 신속성</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            항시 수요에 부응한 다양한 차량이 준비되어 있어 이용자의 요구에 따라 신속하게 대여
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="title font-weight-bold">차량 운행의 경제성 및 무제한성</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul>
                                                <li class="ml-5">고유가 시대에 차량 연료비 절감이 탁월한 LPG 차량을 이용할 수 있음</li>
                                                <li class="ml-5">新고유가에 따른 부제운행정책 등에도 사업용 차량으로 분류되어 운행제한을 받지 않음</li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="title font-weight-bold">대여 기간의 탄력성</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            차량의 범위 내에서 이용자가 원하는 기간만큼(몇 시간부터 몇 년까지) 계약을 통해 대여 자동차를 이용할 수 있음
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="title font-weight-bold">차량관리 및 유지의 편리성</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul>
                                                <li class="ml-5">차량의 관리 및 유지의무(정기점검, 검사, 정비 등)가 대여업체에 있어, 이용자의 이용 편리성 보장</li>
                                                <li class="ml-5">장기대여의 경우 월별 순회점검 및 One Shot Service 등을 통해 이용자의 안전을 최대한 보장</li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="title font-weight-bold">차량운용비용 절감</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul>
                                                <li class="ml-5">차량이용 관련 세금은 대여회사가 부담하나, 대여기간 동안의 대여료 전부를 손비처리 등을 받을 수 있음</li>
                                                <li class="ml-5">특히, 법인인 경우 재무구조의 건전성 유지에 용이</li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header class="title font-weight-bold">계약 만료시의 정산의 명확성</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul>
                                                <li class="ml-5">차량의 관리 및 유지의무(정기점검, 검사, 정비 등)가 대여업체에 있어, 이용자의 이용 편리성 보장</li>
                                                <li class="ml-5">장기대여의 경우 월별 순회점검 및 One Shot Service 등을 통해 이용자의 안전을 최대한 보장</li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: "AboutMain",

  data: () => ({})
};
</script>

<style scoped>

</style>
